<template>
  <form action="" class="max-w-[700px] mx-auto" @submit.prevent="$emit('processForm', postcode, product)">
    <div class="form-field-wrap">
      <div class="field-wrap">
        <div class="field-left">
          <input name="postcode-num" id="postcode-num" v-model="postcode" placeholder="Enter a UK postcode" />
        </div>
        <div class="field-right">
          <div class="submit-btn">
            <span class="submit-design">
              <input type="submit" value="Search" class="cursor-pointer" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="radio-wrap">
      <div class="radio-btn-wrap">
        <div class="radio-inner-wrap">
          <input type="radio" id="all-products" name="find-bdm" v-model="product" value="All" checked />
          <label for="all-products">All products</label>
        </div>
        <div class="radio-inner-wrap">
          <input type="radio" id="btl" name="find-bdm" v-model="product" value="BTL" />
          <label for="btl">BTL</label>
        </div>
        <div class="radio-inner-wrap">
          <input type="radio" id="bridging" name="find-bdm" v-model="product" value="Bridging" />
          <label for="bridging">Bridging</label>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  // props: {
  //   categories: Array,
  // },export default {
  data() {
    return {
      postcode: '',
      product: 'All',
    };
  },
  methods: {},
  emits: ['processForm'],
};
</script>
